import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: ${({ $height }) => $height ?? '100%'};
  display: flex;
  margin-top: ${({ $margin }) => $margin};
  margin-bottom: ${({ $margin }) => $margin};
  align-items: center;
  justify-content: center;
`;
const Card = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ $card }) => ($card ? '250px' : 'fit-content')};
  height: ${({ $card }) => ($card ? '250px' : 'fit-content')};
  justify-content: center;
  align-items: center;
  background-color: ${({ $card }) => ($card ? 'red' : 'transparent')};
  border-radius: 15px;
`;

const styledLoader = {
  Container,
  Card,
};

export default styledLoader;
